<template>
  <ActiveRanking v-if="liveRanking" :rankData="rankData" />
  <InactiveRanking v-else :rankData="rankData" />
</template>

<script>
import ActiveRanking from './ActiveRanking.vue'
import InactiveRanking from './InactiveRanking.vue'

export default {
  name: 'AdRankTooltip',
  components: {
    ActiveRanking,
    InactiveRanking
  },
  props: {
    rankData: {
      type: Object,
      required: true
    },
    liveRanking: {
      type: Boolean,
      required: true
    }
  }
}
</script>